import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CustomModalService } from '@piqet-angular/shared';
import { AdministratorService } from 'libs/data/src/lib/services/administrator/administrator.service';

@Component({
  selector: 'piqet-angular-new-processing-waste',
  templateUrl: './new-processing-waste.component.html',
  styleUrls: ['./new-processing-waste.component.scss'],
})
export class NewProcessingWasteComponent {
  headerData: any;
  headerName = '';
  modalLabel: any;
  wasteData: any;
  wasteForm!: FormGroup;
  wasteAddEditForm!: FormGroup;
  submitted = false;
  activatedRoute: any;
  processingWasteList: any;
  regionList: any;
  regionData: any;
  selectRegion: any;
  setIndicatorData: any;
  indicatorList: any;
  isHideDropDown!: boolean;
  isDisabledDropDown!: boolean;
  @Output() saveNewWasteEvent = new EventEmitter<any>();

  constructor(
    private formBuilder: FormBuilder,
    private modal: CustomModalService,
    private administratorService: AdministratorService
  ) {
    this.activatedRoute = this.modal?.modalService?.config?.initialState?.['pathName'];
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['label'];
    this.wasteData = this.modal?.modalService?.config?.initialState?.['newWasteData'];
    this.isDisabledDropDown = this.modalLabel == 'Review waste detail' ? true : false;
    this.indicatorList = this.wasteData.indicatiorList;
    this.processingWasteList = this.wasteData.wasteItems;
    this.regionList = this.wasteData.regionItems;
    this.getRegionData();
  }

  ngOnInit(): void {
    const form = [];
    for (let i = 0; i < this.indicatorList.length; i++) {
      form[this.indicatorList[i].name] = new FormControl(
        this.wasteData.indicatiorList[i].defaultValue || 0,
        Validators.required
      );
    }
    this.wasteForm = new FormGroup(form);
    this.wasteAddEditForm = this.formBuilder.group({
      waste: [this.wasteData.wasteId || null, Validators.required],
      region: [null, Validators.required],
    });
    this.setFormData();
  }

  onClose() {
    this.modal.close();
  }

  onChange(value: any) {
    this.wasteAddEditForm.controls['region'].setValue(null);
    if (!!value?.id) {
      this.administratorService.GetRegionsForWaste(value.id).subscribe((data: any) => {
        this.regionData = data.data;
      });
    } else {
      this.regionData = [];
    }
  }

  commonInputSearch(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }

  async getRegionData() {
    await this.regionList.map((item: any) => {
      if (item.id == this.wasteData.regionId) {
        return (this.selectRegion = item);
      }
    });
  }
  setFormData() {
    this.wasteAddEditForm.patchValue({ region: this.selectRegion });
  }

  onSave() {
    this.submitted = true;
    if (
      this.wasteAddEditForm.controls['region'].value?.name == 'Region' ||
      (this.activatedRoute == 'processing-data-conversion' &&
        !this.wasteAddEditForm.controls['region'].value?.name)
    ) {
      return;
    }
    if (this.wasteAddEditForm.status == 'VALID' && this.wasteForm.status == 'VALID') {
      const entires = Object.entries(this.wasteForm.value);
      const resultArray: any = [];
      let i = {};
      const entiresArray = this.wasteData.indicatiorList.map((obj: any, index: any) => ({
        ...obj,
        ...entires[index],
      }));
      entiresArray.forEach((event: any, index: any) => {
        i = {
          indicatorId: event.indicatorId,
          name: event.name,
          unit: event.unit,
          defaultValue: event[1],
          equivalencyUnits: event.equivalencyUnits,
          multiplier: event.multiplier,
        };
        resultArray.push(i);
      });
      const storagePayload = {
        wasteId: this.wasteAddEditForm.controls['waste'].value,
        regionId: this.wasteAddEditForm.controls['region'].value?.id || this.wasteData.regionId,
        indicatiorList: resultArray,
      };
      this.saveNewWasteEvent.emit(storagePayload);
      this.onClose();
    }
  }
}
